import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// ---------------------------------------------------------------------------
// Registrasi Chart.js terpusat (single source of truth).
//
// Sebelumnya ChartJS.register(...) dipanggil berulang di 6 komponen chart
// (Statistic, Masuk, Keluar, Dompet, Harian, User). Semua elemen di sini
// didaftarkan SEKALI di src/index.js, sehingga komponen cukup import
// komponen chart dari 'react-chartjs-2'.
// ---------------------------------------------------------------------------
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);
